<template>
    <div class="module">
        <header class="module__header">
            <h1>Change Password</h1>
        </header>

        <section class="module__body">
            <form @submit.prevent="changePassword">
                <div class="form-flex">
                    <div class="form-flex-group">
                        <div class="form-group">
                            <label for="password">Current Password</label>
                            <input
                                v-model="password"
                                type="password"
                                required
                                maxlength="255"
                            />
                        </div>

                        <div class="form-group">
                            <label for="title">New Password</label>
                            <input
                                v-model="new_password"
                                type="password"
                                required
                                maxlength="255"
                            />
                        </div>

                        <div class="form-group">
                            <label for="username">Confirm New Password</label>
                            <input
                                v-model="new_password_confirmation"
                                type="password"
                                required
                                maxlength="255"
                            />
                        </div>
                    </div>
                </div>

                <form-errors :response="errorResponse"></form-errors>

                <div class="form-group">
                    <button
                        type="submit"
                        class="btn btn-primary"
                        :class="{ active: submitted }"
                    >
                        <div>Change</div>
                    </button>
                </div>
            </form>
        </section>
    </div>
</template>

<script>
import FormErrors from '@/components/FormErrors.vue'
import canToast from '@/mixins/canToast'

export default {
    components: {
        FormErrors,
    },

    mixins: [canToast],

    data() {
        return {
            password: null,
            new_password: null,
            new_password_confirmation: null,
            errorResponse: null,
            submitted: false,
        }
    },

    methods: {
        changePassword() {
            this.submitted = true

            this.$http
                .post('auth/change-password', {
                    password: this.password,
                    new_password: this.new_password,
                    new_password_confirmation: this.new_password_confirmation,
                })
                .then(() => {
                    this.toast('Password successfully updated!')
                    this.$router.push('/')
                })
                .catch((error) => {
                    this.errorResponse = error.response
                    this.submitted = false
                })
        },
    },
}
</script>
